import React, { useState } from 'react';
import { ethers } from 'ethers';
import { usePackageTiers } from '../../hooks/usePackageTiers';
import { useXtPrice } from '../../hooks/useXtPrice';
import { formatUSDT } from '../../utils/format';
import { PageLoader } from '../common/Loader';
import MachineCard from './MachineCard';
import MachineDetailModal from './MachineDetailModal';
import './Machines.css';

// Safe defaults so nothing crashes while user data is still loading
const EMPTY_BALANCES = {
  usdt: ethers.BigNumber.from(0),
  xt: ethers.BigNumber.from(0),
  allowance: ethers.BigNumber.from(0),
};

export default function InvestForm({ balances, onDone, isRegistered }) {
  const { tiers, loading: tiersLoading } = usePackageTiers();
  const { xtPrice } = useXtPrice();
  const [openIdx, setOpenIdx] = useState(null);

  const safeBalances = balances || EMPTY_BALANCES;

  if (tiersLoading && !tiers.length) {
    return <PageLoader label="LOADING MACHINES" sub="Fetching machine catalog..." />;
  }

  const openTier = openIdx !== null ? tiers[openIdx] : null;

  // Highest-priced machines at the top, lowest at the bottom.
  // Preserve the original tier index so on-chain calls stay correct.
  const sortedTiers = tiers
    .map((tier, i) => ({ tier, i }))
    .sort((a, b) => {
      // Descending by priceUSDT (BigNumber-safe comparison)
      try {
        if (a.tier.priceUSDT.gt(b.tier.priceUSDT)) return -1;
        if (a.tier.priceUSDT.lt(b.tier.priceUSDT)) return 1;
        return 0;
      } catch {
        return Number(b.tier.priceUSDT) - Number(a.tier.priceUSDT);
      }
    });

  return (
    <div>
      <div className="balance-strip">
        <div className="item">USDT Balance <strong>{formatUSDT(safeBalances.usdt)}</strong></div>
        <div className="item">XT Balance <strong>{formatUSDT(safeBalances.xt, 4)}</strong></div>
      </div>

      <div className="machine-grid">
        {sortedTiers.map(({ tier, i }) => (
          <MachineCard
            key={i}
            tier={tier}
            index={i}
            selected={openIdx === i}
            onOpen={setOpenIdx}
          />
        ))}
      </div>

      {openTier && (
        <MachineDetailModal
          tierIndex={openIdx}
          tier={openTier}
          balances={safeBalances}
          xtPrice={xtPrice}
          onClose={() => setOpenIdx(null)}
          onDone={onDone}
          isRegistered={isRegistered}
        />
      )}
    </div>
  );
}
